module.exports = require("./scripts/index.ts");


//////////////////
// WEBPACK FOOTER
// ./model.xml
// module id = 0
// module chunks = 0